// extracted by mini-css-extract-plugin
module.exports = {"wrapperBodyModalSync":"modalsync_wrapperBodyModalSync__r8ypX","wrapperListProduct":"modalsync_wrapperListProduct__1gf0h"};